<ng-template #template>
    <td mat-cell
        [attr.colspan]="colspan"
        class="supplier-cell cell"
        [class.editable]="isEditable"
        [hidden]="editSupplier"
        (click)="onClickEvent()">
        <div class="label">{{ wording.supplier }}</div>

        <span>{{ selectedOption }}</span>

        <input type="text"
               (focus)="setEdit()"
               #focuser
               class="focuser"
               *ngIf="isEditable">
    </td>

    <td mat-cell
        *ngIf="isEditable"
        class="supplier-cell cell"
        [attr.colspan]="colspan"
        [class.editable]="isEditable"
        [hidden]="!editSupplier">
        <autocomplete #autocomplete
                      [fieldConfig]="fieldConfig"
                      [options]="filteredOptions"
                      [autoActiveFirstOption]="false"
                      [forceFocus]="editSupplier"
                      [forceBlur]="isBlurOnInput"
                      [displayFn]="displaySupplier.bind(this)"
                      [isExactMatchFn]="isExactMatch.bind(this)"
                      [createFn]="hasPermissionToCreate && createSupplier.bind(this)"
                      [autocompleteDisabled]="autocompleteDisabled"
                      (onBlur)="unsetEdit()"
                      (onValueSelected)="valueSelected()"
                      (onChangeInput)="changeInput($event)"
                      (onOpenPanel)="openPanel()"
                      (onClosePanel)="closePanel()"
                      (onKeyUp)="onKeyUp($event)">
            <ng-template let-option>
                {{ option.name }}
            </ng-template>
        </autocomplete>
    </td>
</ng-template>